"use client";

import { useRouter } from "next/navigation";
import { Button } from "../button";
import { H3 } from "../typography";

interface BackButtonProps {
  label?: string;
  onClick?: () => void;
}

export function BackButtonPrimary({ label = "", onClick }: BackButtonProps) {
  const router = useRouter();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      router.back();
    }
  };

  return (
    <Button
      variant="text"
      onClick={handleClick}
      className="inline-flex items-center gap-2 text-gray-400 hover:text-white"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z"
          fill="currentColor"
        />
      </svg>
      {label && <H3 className="text-primary">{label}</H3>}
    </Button>
  );
}
